import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { RouteComponentProps } from 'react-router';
import { getPostsDeviationsStreamId } from '../../../streams/posts';
import { PostsSortOrder, PostsType } from '../../../../types/posts';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';

import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';

import { Props, RouteParams } from './PostsSection';

type StateProps = Pick<
  Props,
  'isOwner' | 'ownerUsername' | 'sortOrder' | 'total'
>;
type OwnProps = Omit<
  Props & RouteComponentProps<RouteParams>,
  keyof StateProps
>;

export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = (state, ownProps) => {
  const journalsTotal = streamSelectors.getTotal(
    state,
    getPostsDeviationsStreamId({ type: PostsType.JOURNALS })
  );
  const pollsTotal = streamSelectors.getTotal(
    state,
    getPostsDeviationsStreamId({ type: PostsType.POLLS })
  );
  const statusesTotal = streamSelectors.getTotal(
    state,
    getPostsDeviationsStreamId({ type: PostsType.STATUSES })
  );
  const draftsTotal = streamSelectors.getTotal(
    state,
    getPostsDeviationsStreamId({ type: PostsType.DRAFTS })
  );

  const allTotal = journalsTotal + pollsTotal + statusesTotal + draftsTotal;

  return {
    isOwner: isCurrentUserProfileOwner(state),
    ownerUsername: getProfileOwnerUser(state).username,
    sortOrder: (ownProps.match.params.sortOrder ||
      PostsSortOrder.NEWEST) as PostsSortOrder,
    total: {
      all: isNaN(allTotal) ? 0 : allTotal,
      journals: journalsTotal,
      polls: pollsTotal,
      statuses: statusesTotal,
      drafts: draftsTotal,
    },
  };
};

export default connect(mapStateToProps);
